import { ApiError } from "@softmax/observatory-client/transport";

export function isUncertainWrite(error: Error) {
  return (
    (error instanceof ApiError &&
      (error.status === 408 || error.status >= 500)) ||
    error instanceof TypeError ||
    error instanceof SyntaxError ||
    error.name === "AbortError" ||
    error.name === "TimeoutError"
  );
}
